export class GetSponserFilter { 
  SponserIdOrName !: string;
  Name !: string;
  SponserId!:string;
  IsActive!: string;
  GroupIds !: string;
}